import {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux';
import {get_current_position, carrier_watch_position, carrier_position_response} from '../store/slices/carrierPosition';
import { connectOrderSocket, disConnectOrderSocket} from "../store/slices/order";
import connectSocket from "../services/socket/connection";

function CarrierRealTimeLocation() {

    const dispatch = useDispatch();
    const useType = useSelector(e => e.basicInfo?.userDetails?.user_type);
    const orderList = useSelector(e => e.order?.orderList);

    const isSocketConnected = useSelector((state) => state.order?.isSocketConnected);
    const orderSocket = useSelector((state) => state.order?.socket);
    
    const accessToken = JSON.parse(localStorage.getItem("auth_token"))?.access;


    // Connect order socket
    useEffect(() => {
        if (!isSocketConnected && useType && useType === "carrier" && orderList?.length > 0) {
            dispatch(
                connectSocket(
                    `/order/?Authorization=${accessToken}`,
                    connectOrderSocket,
                    disConnectOrderSocket
                )
            );
        };
    }, [accessToken, useType, orderList]);



    useEffect(()=>{

        if(useType && useType === "carrier" && orderList?.length > 0){
            
            // user curretn location only
            const current_position = (e) =>{
                var latLng = {
                    lat: e.coords.latitude,
                    lng: e.coords.longitude
                };
                dispatch(get_current_position(latLng));
                dispatch(carrier_position_response('ok'));
            };

            const getError = (e) => {
                dispatch(carrier_position_response('error'));
            };
            
            navigator.geolocation.getCurrentPosition(current_position, getError);
            
        
            // user watching location only
            const real_time_position = (e) =>{
                var latLng = {
                    lat: e.coords.latitude,
                    lng: e.coords.longitude
                };
                dispatch(carrier_watch_position(latLng));
                dispatch(carrier_position_response('ok'));

                if(orderSocket && latLng){
                    orderSocket.send(
                      JSON.stringify({
                        command: "send_carrier_current_location",
                        current_location : latLng
                      })
                    );
                };
            };

            const watchError = (e) => {
                dispatch(carrier_position_response('error'));
            };
        
            navigator.geolocation.watchPosition(real_time_position, watchError);
            
        };

    },[useType, orderList, orderSocket])


    

  return
}

export default CarrierRealTimeLocation
